import PageLayout from './PageLayout';

export default PageLayout;



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/Poster/Components/PageLayout/index.ts